import api from './api';

const SkillService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/skills/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching skills:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/skills/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching skill:', error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/skills/', data);
      return response.data;
    } catch (error) {
      console.error('Error creating skill:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/skills/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating skill:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/skills/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting skill:', error);
      throw error;
    }
  }
};

export default SkillService;
